<script setup>
import {computed, ref, watch} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import {useComponentsStore} from '@/stores/components'
import {useUserStore} from '@/stores/user'
import {useViewStore} from '@/stores/view'

import Button from '@/common/Button.vue'
import api from '@/services/api'

const props = defineProps({
    viewId: String
})

const viewStore = useViewStore(props.viewId)

const route = useRoute()
const router = useRouter()

const componentsStore = useComponentsStore()
const userStore = useUserStore()

const hasVariations = ref(false)

const tableName = computed(() => viewStore.tableName)
const componentId = computed(() => tableName.value ? componentsStore.componentIds[tableName.value] : undefined)
const show = computed(() => hasAccess.value && !viewStore.showArchive && tableName.value !== 'm_basket_orders' && addNew.value)
const productTypeId = computed(() => tableName.value === 'product_options' ? parseInt(route.query.productTypeId || 0) : undefined)
const hasAddAccess = computed(() => tableName.value ? userStore.access(tableName.value, 'add') : false)
const hasAccess = computed(() => hasAddAccess.value && !hasVariations.value)

const addNew = computed(() => {
    if (!componentId.value) return false
    let component = componentsStore.items.find(o => o.id === componentId.value)
    return !!(component && component.addNew)
})

// Native fetch logic replacing useAsyncState
watch(
    productTypeId,
    async (newTypeId) => {
        if (newTypeId) {
            const obj = await api.post('api/ProductTypes/hasVariations', {
                typeId: newTypeId,
            })
            hasVariations.value = obj && obj.data ? obj.data.count > 0 : false
        } else {
            hasVariations.value = false
        }
    },
    {immediate: true}
)

// Methods
const onClick = () => {
    router.push({
        name: 'form',
        params: {id: 0},
        query: route.query
    })
}
</script>

<template>
    <!-- Note: In Vue 2.7 Composition API with standard native components, @click handles native clicks automatically.
         If Button is a custom component, we retain standard click tracking. -->
    <Button v-if="show" class="rounded-0" @click="onClick">
        <i class="bi-plus-lg"/>
    </Button>
</template>